// translates the data from apps/webserver/src/client/locations/js/components/newLocationUpload/utils/constants.ts - commodities
export var MAP_SPAM_COMMODITY = {
    COCO: 'Cocoa',
    COFF: 'Coffee',
    OILP: 'Palm Oil',
    RUBB: 'Rubber',
    SOYB: 'Soy',
    SUGC: 'Sugar Cane',
};
